import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.css']
})
export class RangeSliderComponent implements OnInit {

  @Input() public min = 1;
  @Input() public max = 100;
  @Input() public value = null;

  @Output() public valueChange = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/range-slider/range-slider.component.ts